module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/settings/integrations/xero/PayrollItem.ejs -->\n<td class="td-nowrap">\n    ';
 if ((mappingType === 'base' || mappingType === 'gross') && model.get('label') === 'HRDF') { 
__p+='\n        HRDF (Employer)\n    ';
 } else { 
__p+='\n        '+
((__t=( model.get('label') ))==null?'':_.escape(__t))+
'\n    ';
 } 
__p+='\n</td>\n\n<td>\n        <select name="debitAccount" class="form-control js-debit-account">\n            <option></option>\n            ';
 debitAccounts && debitAccounts.forEach(function (account) { 
__p+='\n                <option value="'+
((__t=( account.id ))==null?'':_.escape(__t))+
'"\n                    '+
((__t=( model.get('debitAccount') === account.id ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n                    '+
((__t=( account.label ))==null?'':_.escape(__t))+
'\n                </option>\n            ';
 }) 
__p+='\n        </select>\n    </td>\n\n<td>\n    <select name="creditAccount" class="form-control js-credit-account">\n        <option></option>\n        ';
 creditAccounts && creditAccounts.forEach(function (account) { 
__p+='\n            <option value="'+
((__t=( account.id ))==null?'':_.escape(__t))+
'"\n                '+
((__t=( model.get('creditAccount') === account.id ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n                '+
((__t=( account.label ))==null?'':_.escape(__t))+
'\n            </option>\n        ';
 }) 
__p+='\n    </select>\n</td>\n\n<td>\n    <select name="contact" class="form-control js-contact">\n        <option></option>\n        ';
 contacts && contacts.forEach(function (contact) { 
__p+='\n            <option value="'+
((__t=( contact.id ))==null?'':_.escape(__t))+
'"\n                '+
((__t=( model.get('contact') === contact.id ? 'selected': '' ))==null?'':_.escape(__t))+
'>\n                '+
((__t=( contact.label ))==null?'':_.escape(__t))+
'\n            </option>\n        ';
 }) 
__p+='\n    </select>\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/settings/integrations/xero/PayrollItem.ejs
// module id = 878
// module chunks = 1